import { Col, Row } from '@/components';
import type { CSSProperties, FC, ReactNode } from 'react';

type Props = {
  items: ReactNode[];
  mode?: 'fullLine' | 'splitLeft' | 'fillLeft' | 'fillRight';
  style?: CSSProperties;
};

const CONTENT_ITEMS_GAP = 24;
export const ContentItems: FC<Props> = ({ items: _items, mode, style }) => {
  const items = [..._items].filter(Boolean);
  const itemLength = items.length;

  if (itemLength === 0 || itemLength >= 4) {
    return null;
  }

  return (
    <Row gutter={itemLength >= 2 ? CONTENT_ITEMS_GAP : undefined} style={style}>
      {itemLength === 1 ? (
        <Col
          span={mode === 'fullLine' ? 24 : undefined}
          style={{
            width: mode === 'fullLine' ? undefined : 'calc(50% - 12px)',
          }}
        >
          {items[0]}
        </Col>
      ) : null}
      {itemLength === 2 ? (
        <>
          {mode === 'splitLeft' ? (
            <Col span={12}>
              <Row gutter={CONTENT_ITEMS_GAP}>
                <Col span={12}>{items[0]}</Col>
                <Col span={12}>{items[1]}</Col>
              </Row>
            </Col>
          ) : (
            <>
              <Col span={12}>{items[0]}</Col>
              <Col span={12}>{items[1]}</Col>
            </>
          )}
        </>
      ) : null}
      {itemLength === 3 ? (
        <>
          {mode === 'fillLeft' ? (
            <>
              <Col span={12}>{items[0]}</Col>
              <Col span={12}>
                <Row gutter={CONTENT_ITEMS_GAP}>
                  <Col span={12}>{items[1]}</Col>
                  <Col span={12}>{items[2]}</Col>
                </Row>
              </Col>
            </>
          ) : mode === 'fillRight' ? (
            <>
              <Col span={12}>
                <Row gutter={CONTENT_ITEMS_GAP}>
                  <Col span={12}>{items[0]}</Col>
                  <Col span={12}>{items[1]}</Col>
                </Row>
              </Col>
              <Col span={12}>{items[2]}</Col>
            </>
          ) : mode === 'fullLine' ? (
            <>
              <Col span={24}>
                <Row gutter={CONTENT_ITEMS_GAP}>
                  <Col span={12}>{items[0]}</Col>
                  <Col span={12}>{items[1]}</Col>
                </Row>
              </Col>
              <Col span={12}>{items[2]}</Col>
            </>
          ) : (
            <>
              <Col span={12}>
                <Row gutter={CONTENT_ITEMS_GAP}>
                  <Col span={12}>{items[0]}</Col>
                  <Col span={12}>{items[1]}</Col>
                </Row>
              </Col>
              <Col span={6}>{items[2]}</Col>
            </>
          )}
        </>
      ) : null}
    </Row>
  );
};
